import createTableStore from "ds/components/Table/store/useTableStore";

import {
  VCS_AGENT_POOL_AGENTS_TABLE_COLUMNS_CONFIG,
  VCS_AGENT_POOL_AGENTS_TABLE_STORAGE_KEY,
} from "./constants";

const useVCSAgentPoolAgentsTableStore = createTableStore({
  storageKey: VCS_AGENT_POOL_AGENTS_TABLE_STORAGE_KEY,
  config: VCS_AGENT_POOL_AGENTS_TABLE_COLUMNS_CONFIG,
});

export default useVCSAgentPoolAgentsTableStore;
